import { Textarea } from '@/components/common/Textarea'
import { CheckboxGroup } from '@/components/common/CheckboxGroup'
import { StepShell, StepGrid } from '../StepShell'
import { MEDICAL_CONDITION_OPTIONS } from '@/lib/constants'

const DEFAULT = {
  conditions: [],
  allergies: '',
  current_medications: '',
  previous_surgeries: '',
}

export function MedicalHistoryStep({ value, onChange }) {
  const v = { ...DEFAULT, ...(value || {}) }
  const set = (patch) => onChange?.({ ...v, ...patch })

  return (
    <StepShell
      eyebrow="Section 3 — Phase 2"
      title="Medical history"
      description="Systemic conditions, allergies, and ongoing medication that may affect treatment."
    >
      <CheckboxGroup
        label="Existing conditions"
        options={MEDICAL_CONDITION_OPTIONS}
        value={v.conditions}
        onChange={(arr) => set({ conditions: arr })}
        columns={2}
      />
      <StepGrid>
        <Textarea
          label="Allergies"
          rows={2}
          value={v.allergies}
          onChange={(e) => set({ allergies: e.target.value })}
          placeholder="e.g. Penicillin, latex"
        />
        <Textarea
          label="Current medications"
          rows={2}
          value={v.current_medications}
          onChange={(e) => set({ current_medications: e.target.value })}
          placeholder="Drug name + dose"
        />
      </StepGrid>
      <Textarea
        label="Previous surgeries / hospitalisation"
        rows={2}
        value={v.previous_surgeries}
        onChange={(e) => set({ previous_surgeries: e.target.value })}
        placeholder="Year, procedure, hospital"
      />
    </StepShell>
  )
}
